import React, { useState, useRef } from "react";
import FooterLogo from "./assets/images/iec-logo.png";
import "./styles/Footer.css";
import { sendMail } from "../utils/sendMail";
import ReCAPTCHA from "react-google-recaptcha";

const Footer = () => {
  const recaptchaRef = useRef(null);

  const [formData, setFormData] = useState({
    enquiry: "",
    name: "",
    email: "",
    mobile: "",
  });

  const [errors, setErrors] = useState({});
  const [captcha, setCaptcha] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const validate = () => {
    let newErrors = {};

    if (!formData.enquiry.trim()) newErrors.enquiry = "Enquiry required";

    if (!formData.name.trim()) newErrors.name = "Name required";

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Valid email required";

    // Indian + International phone validation
    const phoneRegex = /^\+?[1-9]\d{9,14}$/;

    if (!phoneRegex.test(formData.mobile))
      newErrors.mobile =
        "Enter a valid mobile number (e.g. +919876543210 or 9876543210)";

    if (!captcha) newErrors.captcha = "Please verify captcha";

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);

    try {
      const response = await sendMail({
        ...formData,
        captcha,
      });

      if (response.status === "success") {
        alert("Message sent successfully");

        setFormData({
          enquiry: "",
          name: "",
          email: "",
          mobile: "",
        });

        setErrors({});
        setCaptcha(null);

        if (recaptchaRef.current) {
          recaptchaRef.current.reset();
        }
      } else {
        alert("Mail failed");
      }
    } catch (error) {
      console.error(error);
      alert("Server error");
    }

    setLoading(false);
  };
  return (
    <footer className="section-footer" id="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-5">
            <div className="footer-logo-wrapper">
              <a href="/">
                <img
                  src={FooterLogo}
                  alt="India Embroidery"
                  className="w-100"
                />
              </a>
            </div>
            <div className="footer-address-wrapper">
              <a href="https://maps.app.goo.gl/euUQNKjWYCFLhbfQ8">
                India Embroidery Co,
                <span className="d-block">
                  421, 4th Floor, A1, Shah & Nahar Industrial Estate,
                </span>
                <span className="d-block">Dhanraj Mill Compound,</span>
                <span className="d-block">
                  Lower Parel, Mumbai – 400013, India
                </span>
              </a>
              <a href="tel:+919821634700">TEL: +91 98216 34700</a>
              <a href="tel:+919892388652" className="d-block">
                TEL: +91 98923 88652
              </a>
            </div>
            <div className="footer-social-icons">
              <a
                href="https://www.instagram.com/indiaembroideryco/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="social-icon instagram-icon">
                  <div className="social-icon-bloom"></div>
                  <div className="social-icon-sparkle">
                    <div className="social-icon-sparkle-line"></div>
                    <div className="social-icon-sparkle-line"></div>
                    <div className="social-icon-sparkle-line"></div>
                    <div className="social-icon-sparkle-line"></div>
                    <div className="social-icon-sparkle-line"></div>
                  </div>
                  <svg
                    className="social-icon-shape"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                  >
                    <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path>
                  </svg>
                </div>
              </a>
              <a
                href="https://wa.me/919821634700?text=Hello%20I%20would%20like%20to%20enquire%20about%20embroidery%20services."
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="social-icon whatsapp-icon">
                  <div className="social-icon-bloom"></div>
                  <div className="social-icon-sparkle">
                    <div className="social-icon-sparkle-line"></div>
                    <div className="social-icon-sparkle-line"></div>
                    <div className="social-icon-sparkle-line"></div>
                    <div className="social-icon-sparkle-line"></div>
                    <div className="social-icon-sparkle-line"></div>
                  </div>
                  <svg
                    className="social-icon-shape"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M3.50002 12C3.50002 7.30558 7.3056 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C10.3278 20.5 8.77127 20.0182 7.45798 19.1861C7.21357 19.0313 6.91408 18.9899 6.63684 19.0726L3.75769 19.9319L4.84173 17.3953C4.96986 17.0955 4.94379 16.7521 4.77187 16.4751C3.9657 15.176 3.50002 13.6439 3.50002 12ZM12 1.5C6.20103 1.5 1.50002 6.20101 1.50002 12C1.50002 13.8381 1.97316 15.5683 2.80465 17.0727L1.08047 21.107C0.928048 21.4637 0.99561 21.8763 1.25382 22.1657C1.51203 22.4552 1.91432 22.5692 2.28599 22.4582L6.78541 21.1155C8.32245 21.9965 10.1037 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5ZM14.2925 14.1824L12.9783 15.1081C12.3628 14.7575 11.6823 14.2681 10.9997 13.5855C10.2901 12.8759 9.76402 12.1433 9.37612 11.4713L10.2113 10.7624C10.5697 10.4582 10.6678 9.94533 10.447 9.53028L9.38284 7.53028C9.23954 7.26097 8.98116 7.0718 8.68115 7.01654C8.38113 6.96129 8.07231 7.046 7.84247 7.24659L7.52696 7.52195C6.76823 8.18414 6.3195 9.2723 6.69141 10.3741C7.07698 11.5163 7.89983 13.314 9.58552 14.9997C11.3991 16.8133 13.2413 17.5275 14.3186 17.8049C15.1866 18.0283 16.008 17.7288 16.5868 17.2572L17.1783 16.7752C17.4313 16.5691 17.5678 16.2524 17.544 15.9269C17.5201 15.6014 17.3389 15.308 17.0585 15.1409L15.3802 14.1409C15.0412 13.939 14.6152 13.9552 14.2925 14.1824Z"
                    />
                  </svg>
                </div>
              </a>
            </div>
          </div>
          <div className="col-md-7">
            <div className="section-forms-and-details">
              <div className="section-heading">
                <p>Lets Work Together</p>
              </div>
              <div className="section-form">
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <input
                      type="text"
                      name="enquiry"
                      placeholder="Enquiry"
                      value={formData.enquiry}
                      onChange={handleChange}
                    />
                    {errors.enquiry && (
                      <p className="error">{errors.enquiry}</p>
                    )}
                  </div>

                  <div className="form-group">
                    <input
                      type="text"
                      name="name"
                      placeholder="Name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                    {errors.name && <p className="error">{errors.name}</p>}
                  </div>

                  <div className="form-group">
                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && <p className="error">{errors.email}</p>}
                  </div>

                  <div className="form-group">
                    <input
                      type="tel"
                      name="mobile"
                      placeholder="Mobile Number"
                      value={formData.mobile}
                      onChange={handleChange}
                      maxLength={15}
                    />
                    {errors.mobile && <p className="error">{errors.mobile}</p>}
                  </div>

                  <div className="form-group">
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      sitekey="6LfwpoIsAAAAAKbfErRtUze2pr2wTzHa22cEoucS"
                      onChange={(token) => setCaptcha(token)}
                    />

                    {errors.captcha && (
                      <p className="error">{errors.captcha}</p>
                    )}
                  </div>

                  <button
                    className="theme-btn"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? "Sending..." : "Submit"}
                  </button>
                </form>
              </div>
              <div className="footer-copyright">
                <p>
                  &copy; 2026 India Embroidery Co. Design & Developed By{" "}
                  <a
                    href="https://ezephyr.in/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Ezephyr
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
